const getEnv = (env: string) => {
  return (typeof window !== 'undefined' && window[env as keyof Window]) ? window[env as keyof Window] : process.env[env];
};

export default getEnv;
